import { SyntheticEventWithMetaKey } from '/common/models';
import { navigateToURL } from '/helpers';

import { backURL } from './constants';

export const goToApps = (event?: SyntheticEventWithMetaKey) => {
  navigateToURL({ url: backURL, event });
};
